import { ReactComponent as MagicStar } from 'assets/icons/support/magic-star.svg';
import { ReactComponent as StarIcon } from 'assets/icons/support/star.svg';
import { ReactComponent as UnlimitedIcon } from 'assets/icons/support/unlimited.svg';

export const support = {
  'magic-star': MagicStar,
  star: StarIcon,
  unlimited: UnlimitedIcon,
};
